var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFitogramPro = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-navi-fitogrampro",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0785065,16.9644 L12.684235,16.9644 L12.684235,20.4109316 L13.4013316,20.4109316 L13.4013316,19.1828684 L14.0785065,19.1828684 C14.8122611,19.1828684 15.2671958,18.7577474 15.2671958,18.0785263 C15.2637493,17.4127368 14.7857807,16.9644 14.0785065,16.9644 Z",
    id: "XMLID_108_-path",
    fill: "#0084F8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4013316,17.6401474 L14.0653525,17.6401474 C14.2014883,17.6401474 14.5202298,17.6802684 14.5202298,18.0752842 C14.5202298,18.3329158 14.3377389,18.5034158 14.0653525,18.5034158 L13.4013316,18.5034158 L13.4013316,17.6401474 Z",
    id: "XMLID_108_-path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4642037,18.0751105 C18.4642037,17.4023737 17.9992742,16.9642263 17.2756867,16.9642263 L15.8813003,16.9642263 L15.8813003,20.4106421 L16.5984543,20.4106421 L16.5984543,19.1593053 L17.0367311,19.1593053 L17.713906,20.4107 L18.4940731,20.4107 L17.7737598,19.0788316 C18.2151958,18.9182895 18.4642037,18.5569684 18.4642037,18.0751105 Z",
    id: "XMLID_105_-path",
    fill: "#0084F8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6017285,17.6267158 L17.222611,17.6267158 C17.4582924,17.6267158 17.7337807,17.7037158 17.7337807,18.0785263 C17.7337807,18.3729211 17.5612272,18.5235632 17.222611,18.5235632 L16.6017285,18.5235632 L16.6017285,17.6267158 Z",
    id: "XMLID_105_-path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.505953,16.894 C19.4834413,16.894 19.0152376,17.8109947 19.0152376,18.6575316 C19.0152376,19.5408895 19.4036554,20.4812158 20.505953,20.4812158 C21.60153,20.4812158 21.9966684,19.5375316 21.9966684,18.6575316 C21.9932794,17.8109368 21.5318538,16.894 20.505953,16.894 Z",
    id: "XMLID_102_-path",
    fill: "#0084F8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.505953,19.8117211 C20.2270183,19.8117211 19.7590444,19.6644947 19.7590444,18.6607158 C19.7590444,17.8543 20.1640627,17.5732211 20.505953,17.5732211 C20.8513473,17.5732211 21.2529191,17.8574263 21.2529191,18.6607158 C21.2529765,19.4002053 20.9874256,19.8117211 20.505953,19.8117211 Z",
    id: "XMLID_102_-path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_127_",
    fill: "#0084F8",
    points: "2.44222977 2.00364737 0.181342037 5.46685263 15.2405431 5.46685263 17.5014308 2.00364737"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_126_",
    fill: "#0084F8",
    points: "4.19849608 12.9423368 14.2677755 12.9423368 16.5353264 9.47554211 6.46598956 9.47554211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_125_",
    fill: "#0084F8",
    points: "2.28288773 16.9476684 0.0220574413 20.4109316 4.24829765 20.4109316 6.50585379 16.9476684"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFitogramPro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fitogramPro.9ed98aa2.svg";
export { ForwardRef as ReactComponent };